module.exports = __webpack_public_path__ + "img/128x128_star_scannable_binary.fd235246.svg";